// Solitude (Neptune): every lonely star, an unused star that the drawn lines
// hide every other star from, is worth points to the play.
import { ALIGNMENT_NUMBERS as N } from '../constants';
import { lonelyStars } from '../shared/geometry';
import type { AlignmentDef } from '../types';

export const solitude: AlignmentDef = {
  id: 'solitude',
  planet: 'neptune',
  name: 'Solitude',
  text: () => `Each lonely star is worth +${N.solitudeEach} points. A star is lonely when lines hide every other star from it.`,
  playAdd: (ctx) => ({ label: 'Lonely stars', count: lonelyStars(ctx), each: N.solitudeEach }),
};
